export const FemcareChartColors = [
    '#e31d93',
    '#233b96',
    '#ed1d24',
    '#5c5c5c',
    '#bb005a',
    '#00005a',
    '#444444'
]; 